'use client';

import { MultiSelect as MantineMultiSelect, type MultiSelectProps } from '@mantine/core';

type IMultiSelect = MultiSelectProps;

export const MultiSelect = ({ ...props }: IMultiSelect) => <MantineMultiSelect {...props} />;

MultiSelect.displayName = 'MultiSelect';
